/** Shared testId conventions, ported from lum-web's tests.utils + constants.tests. */
export const COMPONENT_TYPE = {
  PAGE_HEADER: 'page-header',
} as const;

/**
 * Resolves a `testId` prop for a DS component: an explicit `testId` wins,
 * otherwise it derives `<componentType>-<name>`; empty when neither is given.
 */
export const getComponentTestIdProp = (
  componentType = '',
  testId = '',
  name = '',
): { testId?: string } => {
  if (testId) return { testId: testId.toLowerCase() };
  if (componentType && name) return { testId: `${componentType.toLowerCase()}-${name.toLowerCase()}` };
  return {};
};
